<template>
    <div class="container">
        <h2 class="profile-page-title mb--4">
            <router-link to="/user/profile/timetables" class="mr-1">{{ $t('my_timetables') }}</router-link>
            <span class="profile-page-title__count">({{ activeTimetables.length }})</span>
        </h2>

        <div>
            <Timetables :id="id" :profile-mode="true"/>
        </div>

    </div>
</template>

<script>
    import timetableApi from "../../../data/TimetablesApi";
    import Timetables from "../../Timetables";

    export default {
        name: 'Browse',
        props: ["id"],

        data() {
            return {
                timetable: {},
                timetables: [],
            }
        },

        computed: {
            activeTimetables() {
                return this.timetables.filter(t => {
                    return t.status === 1
                })
            }
        },

        created() {
            this.fetchTimetables();
        },

        methods: {
            fetchTimetables() {
                timetableApi.fetchMyTimetables()
                    .then(response => {
                        this.timetables = response;
                        for (let timetable of response) {
                            if (Number(timetable.id) === Number(this.id)) {
                                this.timetable = timetable
                                return
                            }
                        }
                    });
            },
        },

        components: {Timetables}
    }
</script>

<style>
    .profile-page-title__count {
        color: #c0c0c0;
        font-size: 1rem;
    }

    /* cards */
    .course-card {
        border: 1px solid #d7e0e5;
        border-radius: 6px;
        margin-bottom: 30px;
        padding: 20px;
        position: relative;
    }

    .course-card-title {
        display: block;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        line-height: 1.4;
    }

    .course-card-title__language {
        color: #c0c0c0;
    }

    .course-card__button {
        border-radius: 18px;
        color: #fff !important;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    }

    .course-card__button--red {
        background-color: #f15a21;
    }

    .course-card__description,
    .course-card__description p {
        color: #999 !important;
        font-size: .9rem !important;
        line-height: normal;
    }
</style>
